import React from 'react';
import { Button } from './ui/Button';
import { trackAddToCart } from '../utils/metaPixel';
const CHECKOUT_URL = 'https://www.tubienestarinterno.com/cart/53346355937617:1';
export function HeroSection() {
  const goToCheckout = () => {
    trackAddToCart();
    window.location.href = CHECKOUT_URL;
  };
  return <section id="hero" className="pt-4 pb-12 px-5" data-id="element-163">
      <div className="max-w-lg mx-auto flex flex-col items-center text-center animate-fade-in-up" data-id="element-164">
        {/* Eyebrow */}
        <div className="inline-block px-3 py-1 mb-6 rounded-full glass border-accent/30" data-id="element-165">
          <span className="text-xs font-bold tracking-widest text-accent uppercase" data-id="element-166">
            MÉTODO PROBADO EN CIUDAD 2026
          </span>
        </div>

        {/* Headline */}
        <h1 className="text-2xl md:text-4xl font-bold text-white mb-8 leading-tight" data-id="element-167">
          ¿Harto de pedir perdón cada vez que cruzas el portal con tu perro?
        </h1>

        {/* Hero Image */}
        <div className="w-full mb-8 relative" data-id="element-168">
          <div className="absolute inset-0 bg-accent/20 blur-3xl rounded-full -z-10 transform scale-90" data-id="element-169"></div>
          <img src="https://cdn.magicpatterns.com/uploads/pvNASk4SKQ57NhxDFS8MzS/imagen_portada.png" alt="DOG-CALM Método" className="w-full h-auto rounded-2xl shadow-2xl border border-teal/20" data-id="element-170" />
        </div>

        {/* Sub-headline */}
        <p className="text-lg text-white/70 mb-10 leading-relaxed" data-id="element-171">
          Activa el protocolo biológico de 7 días para silenciar el cortisol y
          recuperar una correa en sonrisa. Sin fuerza, sin tirones.
        </p>

        {/* CTA */}
        <div className="w-full flex flex-col items-center gap-3" data-id="element-172">
          <Button onClick={goToCheckout} fullWidth className="animate-pulse-soft" data-id="element-173">
            SÍ, QUIERO PASEOS EN CALMA - 9,95€
          </Button>
          <p className="text-white/70 text-sm font-medium" data-id="element-174">
            Pago único. Acceso inmediato. ⭐ 4.9/5 valoración real.
          </p>
        </div>
      </div>
    </section>;
}